import Vue from 'vue'
import Vuex from 'vuex'
import ApiService from '@/services/ApiService.js'
import ObjectType from '@/services/Objects.js'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    user: null,
    title: null
  },
  mutations: {
    SET_USER_DATA(state, userData) {
      state.user = userData
      localStorage.setItem('user', JSON.stringify(userData))
      ApiService.setUserToken(userData.token)
    },
    UPDATE_USER_DATA(state, userData) {
      userData.token = state.user.token
      state.user = userData
      localStorage.setItem('user', JSON.stringify(userData))
    },
    CLEAR_USER_DATA() {
      localStorage.removeItem('user')
      location.reload()
    },
    SET_PAGE_TITLE(state, title) {
      state.title = title
    }
  },
  actions: {
    login({ commit }, credentials) {
      return ApiService.postLogin(credentials).then(({ data }) => {
        commit('SET_USER_DATA', data)
      })
    },
    logout({ commit }) {
      commit('CLEAR_USER_DATA')
    },
    updateUser({ commit }, userDetails) {
      return ApiService.post(ObjectType.User + '/profile', userDetails).then(
        ({ data }) => {
          commit('UPDATE_USER_DATA', data)
        }
      )
    },
    setPageTitle({ commit }, title) {
      commit('SET_PAGE_TITLE', title)
    }
  },
  getters: {
    loggedIn(state) {
      return !!state.user
    }
  }
})
